import React, { memo } from 'react';
import { useEmptyViewComponent } from '../../controllers/selectors/components-hooks.tsx';
import type { EmptyViewComponentProps } from '../../types.tsx';

export const EmptyComponent = memo<EmptyViewComponentProps>(() => {
	const EmptyView = useEmptyViewComponent();

	return EmptyView ? <EmptyView /> : null;
});
